class MenuBestSellersCarousel extends HTMLElement {
  connectedCallback() {
    this.carousel = this.querySelector('.oc-menu-best-sellers__carousel');
    this.thumb = this.querySelector('.oc-menu-best-sellers__progress-thumb');
    if (!this.carousel || !this.thumb) return;

    this.handleUpdate = this.updateProgress.bind(this);
    this.carousel.addEventListener('scroll', this.handleUpdate, { passive: true });

    this.resizeObserver = new ResizeObserver(this.handleUpdate);
    this.resizeObserver.observe(this.carousel);

    this.updateProgress();
  }

  disconnectedCallback() {
    this.carousel?.removeEventListener('scroll', this.handleUpdate);
    this.resizeObserver?.disconnect();
  }

  updateProgress() {
    const { carousel, thumb } = this;
    if (!carousel.scrollWidth) return;

    const track = thumb.parentElement;
    const visibleRatio = carousel.clientWidth / carousel.scrollWidth;
    const thumbWidth = Math.max(16, visibleRatio * track.clientWidth);
    const maxOffset = track.clientWidth - thumbWidth;
    const scrollRatio = carousel.scrollLeft / (carousel.scrollWidth - carousel.clientWidth || 1);

    thumb.style.width = `${thumbWidth}px`;
    thumb.style.transform = `translateX(${scrollRatio * maxOffset}px)`;
  }
}

if (!customElements.get('menu-best-sellers-carousel')) {
  customElements.define('menu-best-sellers-carousel', MenuBestSellersCarousel);
}
